import { keys } from "lodash";

const IMAGE_RECOGNITION_PERSONS = {
  none: {
    color: "#9EE8FD",
    icon: "user-off",
  },
  solo: {
    color: "#68C6E5",
    icon: "user",
  },
  duo: {
    color: "#4DACCA",
    icon: "users-2",
  },
  group: {
    color: "#2192BB",
    icon: "users-3",
  },
  crowd: {
    color: "#1E81A4",
    icon: "users-3",
  },
} as const;

export type ImageRecognitionPersons = keyof typeof IMAGE_RECOGNITION_PERSONS;

export function getImageRecognitionPersonColor(value: ImageRecognitionPersons) {
  return IMAGE_RECOGNITION_PERSONS[value]?.color;
}

export function getImageRecognitionPersonIcon(value: ImageRecognitionPersons) {
  return IMAGE_RECOGNITION_PERSONS[value]?.icon;
}

export function getImageRecognitionPersons() {
  return keys(IMAGE_RECOGNITION_PERSONS);
}

const IMAGE_RECOGNITION_AGE = {
  children: { color: "#6600CC" },
  teenagers: { color: "#955BFF" },
  young_adults: { color: "#AD8EE6" },
  adults: { color: "#D0BBF5" },
  seniors: { color: "#EFE2FD" },
} as const;

export type ImageRecognitionAge = keyof typeof IMAGE_RECOGNITION_AGE;

export function getImageRecognitionAgeColor(value: ImageRecognitionAge) {
  return IMAGE_RECOGNITION_AGE[value]?.color;
}

const IMAGE_RECOGNITION_EMOTIONS = {
  happy: { color: "#669933" },
  angry: { color: "#E64C65" },
} as const;

export type ImageRecognitionEmotions = keyof typeof IMAGE_RECOGNITION_EMOTIONS;

export function getImageRecognitionEmotionColor(
  value: ImageRecognitionEmotions
) {
  return IMAGE_RECOGNITION_EMOTIONS[value]?.color;
}
